var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoModelAssetsIcon = function SvgNoModelAssetsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 52,
    fill: "none",
    viewBox: "0 0 56 52"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    d: "M50.267 25.133c0 13.881-11.253 25.134-25.134 25.134S0 39.014 0 25.133 11.253 0 25.133 0c13.881 0 25.134 11.253 25.134 25.133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 11.5v36a4.5 4.5 0 0 0 4.5 4.5h27a4.5 4.5 0 0 0 4.5-4.5V21.27a4.5 4.5 0 0 0-1.355-3.218l-9.99-9.77A4.5 4.5 0 0 0 31.51 7H14.5a4.5 4.5 0 0 0-4.5 4.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.267 37.267c0 6.222 5.044 11.266 11.266 11.266S55.8 43.49 55.8 37.267 50.756 26 44.533 26s-11.266 5.044-11.266 11.267"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    fillRule: "evenodd",
    d: "m44.646 18.052-9.99-9.77a4.5 4.5 0 0 0-2.01-1.136L32.5 7v.11a4.5 4.5 0 0 0-.99-.11H14.5a4.5 4.5 0 0 0-4.5 4.5v36a4.5 4.5 0 0 0 4.5 4.5h27a4.5 4.5 0 0 0 4.398-3.548q-.519.062-1.053.077A3.5 3.5 0 0 1 41.5 51h-27a3.5 3.5 0 0 1-3.5-3.5v-36A3.5 3.5 0 0 1 14.5 8h17.01a3.5 3.5 0 0 1 .99.143V16a4.5 4.5 0 0 0 4.5 4.5h7.914q.086.379.086.77v4.74q.505.02 1 .085V21.27a4.5 4.5 0 0 0-.066-.77H46l-.081-.081a4.5 4.5 0 0 0-1.273-2.367m-.127 1.448a3.5 3.5 0 0 0-.573-.733l-9.99-9.77a3.5 3.5 0 0 0-.456-.376V16a3.5 3.5 0 0 0 3.5 3.5z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    fillRule: "evenodd",
    d: "M20.75 31.75a.5.5 0 0 1 .5-.5h13.5a.5.5 0 0 1 0 1h-13.5a.5.5 0 0 1-.5-.5m0 9a.5.5 0 0 1 .5-.5H28a.5.5 0 0 1 0 1h-6.75a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.267 37.267c0 6.222 5.044 11.266 11.266 11.266S55.8 43.49 55.8 37.267 50.756 26 44.533 26s-11.266 5.044-11.266 11.267"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.867 37.097a8.497 8.497 0 1 0 16.993 0 8.497 8.497 0 0 0-16.993 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    fillRule: "evenodd",
    d: "M34.867 37.097a9.497 9.497 0 1 0 18.993 0 9.497 9.497 0 0 0-18.993 0m9.496 8.496a8.497 8.497 0 1 1 0-16.993 8.497 8.497 0 0 1 0 16.993",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    fillRule: "evenodd",
    d: "M47.329 40.328a.5.5 0 0 0 0-.707l-4.95-4.95a.5.5 0 0 0-.707.708l4.95 4.95a.5.5 0 0 0 .706 0",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    fillRule: "evenodd",
    d: "M47.328 34.672a.5.5 0 0 0-.707 0l-4.95 4.95a.5.5 0 0 0 .708.706l4.95-4.95a.5.5 0 0 0 0-.706",
    clipRule: "evenodd"
  })));
};
export default SvgNoModelAssetsIcon;